import { ChalkEmployeeGuard } from "@/components/admin/ChalkEmployeeGuard";
import { useGlobalAppState } from "@/utils/app-state";
import { useIsImpersonating } from "@/utils/hooks/use-is-impersonating";
import React from "react";

export const PermissionDebugMessage: React.FC = () => {
  const {
    state: { adminMode, demoMode },
  } = useGlobalAppState();
  const isImpersonating = useIsImpersonating({ cookieOnly: true });
  if (demoMode) return null;

  const backendMessage = isImpersonating
    ? adminMode
      ? ", backend will accept request"
      : ", backend would accept request"
    : adminMode
      ? ", backend will reject request"
      : "";

  return (
    <ChalkEmployeeGuard ignoreAdminMode hideTooltip className="mt-1 rounded px-1 py-0.5">
      [Currently {isImpersonating ? "impersonating" : "not impersonating"}, admin mode{" "}
      {adminMode ? "activated" : "deactivated"}
      {backendMessage}]
    </ChalkEmployeeGuard>
  );
};
